import ModalContainer from "../../../components/ModalContainer";
import logoIcon from "../../../assets/images/logo.svg"
import React from "react";

type Props = {
    isOpen: boolean;
    close: () => void;
}

export const RollOverModal: React.FC<Props> = ({ isOpen, close }) => {
    return (
        <ModalContainer isOpen={isOpen} close={close}>
            <div className={"flex flex-center justifyCenter"} style={{ flexDirection: "column" }}>
                <img src={logoIcon} alt=""/>
                <h2 className={"inter font-size-21 text-weight-600 mt20"}>Credits Balance & Credits Roll-Over</h2>
                <p className={"inter font-size-13 text-weight-400 mt20 line-height-21"}>
                    Your Credits Balance shows the Сredits available for you to use on legal works. <b className={"text-weight-600"}>Purchased credits remain active throughout the current billing period.</b>
                </p>
                <p className={"inter font-size-13 text-weight-400 mt20 line-height-21"}>
                    If you don’t use all your Credits by the end of the period,
                    your contract allows up to <b className={"text-weight-600"}>20 unused credits to roll over</b> into the next billing cycle,
                    <b className={"text-weight-600"}>provided the upcoming period is paid</b>. Any unused <b className={"text-weight-600"}>credits beyond this limit will expire.</b>
                </p>
                <p className={"inter font-size-13 text-weight-400 mt20 line-height-21"}>
                    <b className={"text-weight-600"}>If payment for the next period is not made, no credits will roll over,</b> and all unused credits will expire on their original expiration date.
                </p>

                <button onClick={close} className="btn-black text-uppercase mt25 w100 inter font-size-12">OK</button>
            </div>
        </ModalContainer>
    )
}